import { Fragment } from 'react';
import { OrganType } from '@/api/apis/case';
import { ORGAN_ICON } from '@/utils/helpers';

type SUserCellSubtitleProps = {
  organs: OrganType[];
};

export const SUserCellSubtitle = ({ organs }: SUserCellSubtitleProps) => {
  return (
    <div className="flex gap-1 items-center">
      {Array.from(new Set(organs)).map((o) => {
        const OrganIcon = ORGAN_ICON[o] ?? Fragment;
        return <OrganIcon key={o} className="text-base-5 size-4" />;
      })}
    </div>
  );
};
